import { render, staticRenderFns } from "./designatedStudent.vue?vue&type=template&id=7fa1360e&scoped=true"
import script from "./designatedStudent.vue?vue&type=script&lang=js"
export * from "./designatedStudent.vue?vue&type=script&lang=js"
import style0 from "./designatedStudent.vue?vue&type=style&index=0&id=7fa1360e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1360e",
  null
  
)

export default component.exports